import { render, staticRenderFns } from "./Attempts.vue?vue&type=template&id=04bf02b2&scoped=true&lang=pug"
import script from "./Attempts.vue?vue&type=script&lang=ts"
export * from "./Attempts.vue?vue&type=script&lang=ts"
import style0 from "./Attempts.vue?vue&type=style&index=0&id=04bf02b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf02b2",
  null
  
)

export default component.exports